/**
 * Ek içerik bölümüne bağlı görseli olan yollar (ek_bolum.ts anahtarları, aynı sıra). Layout'un ana paketinde durur:
 * EkIcerikOto görsel modülünü yalnız bu yollarda indirir, diğer sayfaların ağ çıktısı değişmez.
 */
export const EK_BOLUM_GORSELLI_YOLLAR: readonly string[] = [
  "/google-alisveris-reklamlari",
];
